import { render } from "./Older.vue?vue&type=template&id=3786a7e5&scoped=true"
import script from "./Older.vue?vue&type=script&lang=js"
export * from "./Older.vue?vue&type=script&lang=js"

import "./Older.vue?vue&type=style&index=0&id=3786a7e5&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3786a7e5"]])

export default __exports__